import React, { useState } from "react";

import { Avatar, Container, Typography, IconButton } from "@mui/material";
import { Navigate, useParams } from "react-router";

import BackupTableIcon from '@mui/icons-material/BackupTable';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';

import { useUser } from "../context/user.context";
import { Box } from "@mui/system";
import { useTheme } from "@emotion/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import EditTable from "../components/EditTable";
import EditPeriods from "../components/EditPeriods";
import AddPeriod from "../components/AddPeriod";
import Period from "../components/Period";
import EditPeriod from "../components/EditPeriod";

// ======================================================= //

export default function TimeTable() {

    let {id} = useParams();
    const {user} = useUser();

    // useParams returns a string
    id = parseInt(id);

    // check if the table even exists?
    let found = -1;
    user.tables.forEach((v, i) => {
        
        if(v.id === id) {
            found = i;
        }
    });

    // ------------------------------------------------------- //
    
    const {main} = useTheme().palette.primary;
    const [table, setTable] = useState(user.tables[found]);

    const [addOpen, setAddOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);

    const [adding, setAdding] = useState({day: 'Monday', index: 0});

    // ------------------------------------------------------- //

    const handleAddOpen = (day, index) => {

        setAddOpen(true);

        setAdding(p => {
            p.day = day;
            p.index = index;
            return p;
        });
    }

    const handlePeriodEdit = (day, index) => {
        
        setAdding(p => {
            p.day = day;
            p.index = index;
            return p;
        });
        
        setEditOpen(true);
    }

    // ------------------------------------------------------- //

    // if it doesn't exist, go back
    if(found === -1) return <Navigate to="/" />

    // ------------------------------------------------------- //

    const columns = [
        {
            name: 'Day',
            selector: row => row.day,
            grow: 1,
            style: {fontWeight: 600}
        },
    ];

    table.periods.forEach((v, i) => {
        
        if(!v.hidden) {
            columns.push({
                name: v.start + " - " + v.end,
                minWidth: "140px",
                selector: row => row.periods[i] === null 
                    ? <IconButton onClick={() => handleAddOpen(row.day, i)}><AddIcon/></IconButton> 
                    : <Period period={row.periods[i]} index={i} day={row.day} handleEdit={handlePeriodEdit}/>
            })
        }
    })

    // ------------------------------------------------------- //

    return (
        <Container maxWidth="xl">

            <Link to='/' style={{textDecoration: "none"}}>
                <IconButton>
                    <ArrowBackIcon/>
                </IconButton>
            
                <Typography variant="caption" color="secondary" marginTop="1.5vh">
                    Go Back
                </Typography>
            </Link>
            
            <Box
                sx={{
                    marginTop: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >

                <Avatar sx={{ m: 1, bgcolor: main }}>
                    <BackupTableIcon />
                </Avatar>
                
                <Typography
                    component="h1"
                    variant="h5"
                    align="center"
                    color="text.primary"
                    fontWeight="600"
                    marginTop="2vh"
                >
                {table.name}
                </Typography>
 
                <EditTable table={table} tableIndex={found} setTable={setTable}/>
       
                <DataTable
                    columns={columns}
                    data={table.days}
                    fixedHeader
                    responsive
                    striped
                />

                <EditPeriods table={table}/>
                <AddPeriod open={addOpen} adding={adding} setAddOpen={setAddOpen} index={found}/>
                <EditPeriod open={editOpen} adding={adding} setEditOpen={setEditOpen} index={found}/>
                
            </Box>

        </Container>
    )
}

// ======================================================= //